import React, { useEffect } from 'react'
import {
  CountriesLutProvider, CustomBehaviourProvider,
  OrganizationTypeLutProvider,
  PositionLutProvider,
  PrefixProvider,
  RegionProvider,
  UrlDescTypeProvider,
  UsPrefixProvider
} from 'components'
import { useSessionContext } from 'session'

export interface ProtectedRouteProps {
  page: React.ReactElement
}

export const ProtectedPage: React.FC<ProtectedRouteProps> = ({ page }) => {
  const { sessionData } = useSessionContext()
  useEffect(() => {
    if (sessionData.region == null) {
      window.location.href = '/login'
    }
  }, [sessionData.region])
  return <>
      <OrganizationTypeLutProvider>
        <PositionLutProvider>
          <CountriesLutProvider>
            <UrlDescTypeProvider>
              <PrefixProvider>
                <UsPrefixProvider>
                  <RegionProvider>
                    <CustomBehaviourProvider>
                    {page}
                    </CustomBehaviourProvider>
                  </RegionProvider>
                </UsPrefixProvider>
              </PrefixProvider>
            </UrlDescTypeProvider>
          </CountriesLutProvider>
        </PositionLutProvider>
        </OrganizationTypeLutProvider>
  </>
}
